import * as React from 'react';
import { getIsWhiteLabel } from '@/redux/modules/whiteLabel';
import LAFooter from './LAFooter/LAFooter';
import { useSelector } from 'react-redux';
import WhiteLabelFooter from './WhiteLabelFooter/WhiteLabelFooter';

const Footer = () => {
    const whiteLabel = useSelector(getIsWhiteLabel);
    return whiteLabel ? <WhiteLabelFooter /> : <LAFooter />;
};

// because whitelabel will never update we can keep memo
export default React.memo(Footer);
